import { render, staticRenderFns } from "./RessetPW.vue?vue&type=template&id=1d19f88a"
import script from "./RessetPW.vue?vue&type=script&lang=js"
export * from "./RessetPW.vue?vue&type=script&lang=js"
import style0 from "./RessetPW.vue?vue&type=style&index=0&id=1d19f88a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports